'use strict';

module.exports = function() {
	return function (translationID) {
        return '';
    };
};